import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=41ee27d3&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ee27d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ee27d3')) {
      api.createRecord('41ee27d3', component.options)
    } else {
      api.reload('41ee27d3', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=41ee27d3&scoped=true&", function () {
      api.rerender('41ee27d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Final/Message.vue"
export default component.exports